module.exports = __webpack_public_path__ + "img/kk_get.2f77fa4.png";